import { render, staticRenderFns } from "./wifiPlanner.vue?vue&type=template&id=60ab5951&scoped=true&"
import script from "./wifiPlanner.vue?vue&type=script&lang=tsx&"
export * from "./wifiPlanner.vue?vue&type=script&lang=tsx&"
import style0 from "./wifiPlanner.vue?vue&type=style&index=0&id=60ab5951&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ab5951",
  null
  
)

export default component.exports